import React, { useEffect, createElement } from 'react';
const GTMBodyScript = () => {
  useEffect(() => {
    // Create the noscript element
    const noscriptElement = document.createElement('noscript');
    // Create the iframe element
    const iframeElement = document.createElement('iframe');
    iframeElement.src = 'https://www.googletagmanager.com/ns.html?id=GTM-WDJHH66';
    iframeElement.height = '0';
    iframeElement.width = '0';
    iframeElement.style.display = 'none';
    iframeElement.style.visibility = 'hidden';
    // Append iframe to noscript
    noscriptElement.appendChild(iframeElement);
    // Insert the noscript element as the first child of body
    // This ensures it's right after the opening body tag
    if (document.body.firstChild) {
      document.body.insertBefore(noscriptElement, document.body.firstChild);
    } else {
      document.body.appendChild(noscriptElement);
    }
    // Cleanup function
    return () => {
      if (document.body.contains(noscriptElement)) {
        document.body.removeChild(noscriptElement);
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount
  return null; // This component doesn't render anything visible
};
export default GTMBodyScript;